import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
import welcomeMessage from './welcome-message'
/**
* @see \App\Actions\Admin\UpdateSettings::__invoke
* @see app/Actions/Admin/UpdateSettings.php:17
* @route '/admin/settings'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/admin/settings',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Actions\Admin\UpdateSettings::__invoke
* @see app/Actions/Admin/UpdateSettings.php:17
* @route '/admin/settings'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\UpdateSettings::__invoke
* @see app/Actions/Admin/UpdateSettings.php:17
* @route '/admin/settings'
*/
update.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

const settings = {
    update: Object.assign(update, update),
    welcomeMessage: Object.assign(welcomeMessage, welcomeMessage),
}

export default settings